<template>
    <main-content with_go_back_bar>
        <online-factor-customer-form>
        </online-factor-customer-form>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import Form from './components/form_customer'



export default {
    components: {
        'main-content': mainContent,
        'online-factor-customer-form': Form
    },
}
</script>
